export default __webpack_public_path__ + "images/5O.c0cc8da.png";